// extracted by mini-css-extract-plugin
export default {"tagalign":"tags_tagalign__ywYqZ","tags":"tags_tags__ZAh2Y","is_select":"tags_is_select__4IF4w"};